import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20fantasy%20forest%20scene%20with%20a%20path%20made%20of%20giant%20mushroom%20platforms%20leading%20into%20the%20distance%2C%20golden%20sunlight%20streaming%20through%20trees%2C%20soft%20glowing%20particles%20in%20the%20air%2C%20hand-drawn%20illustration%20style%2C%20warm%20earth%20tones%2C%20inviting%20atmosphere%2C%20a%20sense%20of%20adventure%20and%20discovery%2C%20wide%20panoramic%20landscape%20composition&width=1600&height=600&seq=cta-mushroom-03&orientation=landscape"
        alt="开始冒险"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 max-w-2xl mx-auto text-center px-4">
        <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
          准备好开始你的蘑菇冒险了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
          无论你是刚接触踩蘑菇的新手，还是追求极限的资深玩家，这里都有适合你的攻略内容。立即浏览攻略，和全球玩家一起享受踩蘑菇的无穷乐趣！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category?cat=guanka-gonglue"
            className="bg-primary-500 text-background-50 px-8 py-3 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始查看攻略
          </Link>
          <Link
            to="/about"
            className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-3 rounded-full font-medium text-sm hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}